import { render, staticRenderFns } from "./KioskQuiz.vue?vue&type=template&id=20dc6563&scoped=true"
import script from "./KioskQuiz.vue?vue&type=script&lang=js"
export * from "./KioskQuiz.vue?vue&type=script&lang=js"
import style0 from "./KioskQuiz.vue?vue&type=style&index=0&id=20dc6563&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc6563",
  null
  
)

export default component.exports